export default __webpack_public_path__ + "static/media/training-bgm-neffex-failure.72b71288.mp3";